import { cadOpType } from "lib/operations/factory";
import { EditDataCommand } from "./edit-base";

export class PolylineEditDataCommand extends EditDataCommand {
  protected opType = cadOpType.EDITPOLYLINEVERTEX;
}